var exports = {
  "Z": "x620889e6--d3b847--layout",
};

module.exports = exports;
